import type { QueryParams } from "../../types";

export const themesKeys = {
  all: ["themes"] as const,
  list: (params: QueryParams) => [...themesKeys.all, "list", params] as const,
  detail: (id: number | string | undefined) =>
    [...themesKeys.all, "detail", id] as const,
};
